export default __webpack_public_path__ + "media/images/progress-2-f06cbf3f31701ad341560b72b215d8a5.png";